import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import {BehaviorSubject, Observable} from 'rxjs';
import {QuickSelectionModel, TreeItemNode} from '@shared/models/tree-selector.models';
import {combineLatest, of} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {FxRateState} from '../../store/reducers/fx-rate.reducer';
import {
  GetCountriesTreeDataAction, GetCountriesTreeDataSuccessAction,
  GetCurrenciesTreeDataAction, GetCurrenciesTreeDataSuccessAction
} from '../../store/actions/fx-rate.action';
import {getCountriesTreeData, getCurrenciesTreeData} from '../../store/selectors/fx-rate.selectors';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {FxRateReportModel} from '../../models/fx-rate-report.model';
import {QueryProvider} from '@shared/queries/query-provider';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {skip, take, takeUntil} from 'rxjs/operators';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-fx-rate-currency-selector',
  templateUrl: './fx-rate-currency-selector.component.html',
  styleUrls: ['./fx-rate-currency-selector.component.scss']
})
export class FxRateCurrencySelectorComponent implements OnInit, OnDestroy {
  @Input() reportId: string;
  @Input() currencyType: string;
  @Input() title: string;
  @Input() reportModel: FxRateReportModel;
  @Output() selectionChanged: EventEmitter<any> = new EventEmitter();
  @Output() multipleCurrencySelected: EventEmitter<boolean> = new EventEmitter();
  CurrentSearchKey: string;
  allDataLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  filterTabs = ['Select by Currency', 'Select by Country'];
  treeData$: BehaviorSubject<TreeItemNode[]> = new BehaviorSubject([]);
  countryTreeData$: Observable<TreeItemNode[]>;
  currencyTreeData$: Observable<TreeItemNode[]>;
  countryTreeData: TreeItemNode[];
  currencyTreeData: TreeItemNode[];
  quickSelections$:  Observable<QuickSelectionModel[]>;
  currentTabIndex = 0;
  isParentNodeCollapsible$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  displayProperty = 'title';
  projectCountryCountsQueryKey = 'ProjectCountryCounts';
  countryDictionary: any = {};
  selectedCurrencyCount: number;
  private ngUnsubscribe = new Subject<void>();
  constructor(private store: Store<FxRateState>, private fuseSplashScreenService: FuseSplashScreenService,
              public particleStore: Store<ParticleState>,
              protected queryStore: Store<IQueryState>, ) {
    this.updateQuickSelection(this.currentTabIndex);
  }

  ngOnInit() {

    // const config = QueryProvider.getQuery(this.configKey);
    // QueryProvider.invokeQuery(this.store, this.configKey, {});

    this.selectedCurrencyCount = 0;
    QueryProvider.invokeQuery(this.queryStore, this.projectCountryCountsQueryKey, {});
    this.store.dispatch(new GetCurrenciesTreeDataAction(this.reportId, this.currencyType));
    this.store.dispatch(new GetCountriesTreeDataAction(this.reportId, this.currencyType));
    const projectCountryCounts$ = this.queryStore.pipe(takeUntil(this.ngUnsubscribe), select(getQueryResponse, this.projectCountryCountsQueryKey), skip(1));
    this.currencyTreeData$ = this.store.select(getCurrenciesTreeData(this.reportId, this.currencyType));
    this.countryTreeData$ = this.store.select(getCountriesTreeData(this.reportId, this.currencyType));
    this.currencyTreeData$.pipe( take(2) ).subscribe(data => {
      if (data) {
        this.updateCurrencySelectorTree(data);
      }
    });

    combineLatest(this.countryTreeData$, projectCountryCounts$).subscribe(result => {
      if (result[0] && result[1]) {
        this.countryTreeData = result[0];
        this.countryDictionary = result[1];
        this.updateCountrySelectorTree(this.countryTreeData);
      }
    });
  }
  onSelectionChanged(event: any) {
    this.selectedCurrencyCount = (event.isCurrentTreeNodeChecked) ? (this.selectedCurrencyCount + 1) : (this.selectedCurrencyCount - 1);
    switch (this.currentTabIndex) {
      case 0: {
        this.countryTreeData.forEach(data => {
          if (data.item.cells[this.displayProperty].value == event.currentTreeNode.item.cells[this.displayProperty].value) {
            data.item.isChecked = event.isCurrentTreeNodeChecked;
          }
        });
        this.store.dispatch(new GetCountriesTreeDataSuccessAction(this.reportId, this.currencyType, this.countryTreeData));
        break;
      }
      case 1: {
        const index =  this.currencyTreeData.findIndex(data => data.item.cells[this.displayProperty].value == event.currentTreeNode.item.cells[this.displayProperty].value);
        if (index < 0) { break; }
        const currency = this.currencyTreeData[index];
        if (event.isCurrentTreeNodeChecked) {
          this.currencyTreeData[index].item.isChecked = true;
          this.store.dispatch(new GetCurrenciesTreeDataSuccessAction(this.reportId, this.currencyType, this.currencyTreeData));
        } else {
          let cnt = 0;
          this.countryTreeData.forEach(data => {
            if (data.item.cells[this.displayProperty].value == currency.item.cells[this.displayProperty].value && data.item.isChecked ) {
              cnt++;
            }
          });
          if (cnt > 1) { break; }
          this.currencyTreeData[index].item.isChecked = false;
          this.store.dispatch(new GetCurrenciesTreeDataSuccessAction(this.reportId, this.currencyType, this.currencyTreeData));
        }
        break;
      }
    }
    this.multipleCurrencySelected.emit(this.selectedCurrencyCount > 1);
  }

  onCountryQuickSelectionClick(event: any) {
    if (event.id === 'ALL_CURRENCIES') {
      this.currencyTreeData = this.updateTree(this.currencyTreeData, true);
      this.updateCountryTreeBasedOnCurrencyTree();
      this.treeData$.next(this.currencyTreeData);
    } else if (event.id === 'NO_CURRENCIES') {
      this.currencyTreeData = this.updateTree(this.currencyTreeData, false);
      this.updateCountryTreeBasedOnCurrencyTree();
      this.treeData$.next(this.currencyTreeData);
    } else if (event.id === 'MY_COUNTRIES') {
      this.updateCountrySelectorTreeForQuickSelection();
      this.treeData$.next(this.countryTreeData);
      this.updateCurrencyTreeBasedOnCountryTree();
    } else if (event.id === 'ALL_COUNTRIES') {
      this.countryTreeData = this.updateTree(this.countryTreeData, true);
      this.updateCurrencyTreeBasedOnCountryTree();
      this.treeData$.next(this.countryTreeData);
    } else if (event.id === 'NO_COUNTRIES') {
      this.countryTreeData = this.updateTree(this.countryTreeData, false);
      this.updateCurrencyTreeBasedOnCountryTree();
      this.treeData$.next(this.countryTreeData);
    }
  }

  onTabChanged(event: MatTabChangeEvent) {
    this.fuseSplashScreenService.show();
    this.currentTabIndex = event.index;
    this.updateQuickSelection(event.index);
    this.getData(event.index);
  }

  updateQuickSelection(index) {
    switch (index) {
      case 0: {
        this.quickSelections$ = of([
          {
            name: 'All Currencies',
            id: 'ALL_CURRENCIES'
          },
          {
            name: 'None',
            id: 'NO_CURRENCIES'
          }
        ]);
        break;
      }
      case 1: {
        this.quickSelections$ = of([
          {
            name: 'My Countries',
            id: 'MY_COUNTRIES'
          },
          {
            name: 'All Countries',
            id: 'ALL_COUNTRIES'
          },
          {
            name: 'None',
            id: 'NO_COUNTRIES'
          }
        ]);
        break;
      }
    }
  }

  updateCurrencySelectorTree(data: TreeItemNode[]) {
    this.selectedCurrencyCount = 0;
    data.forEach(node => {
      node.item.title = node.item.cells[this.displayProperty].displayText;
      node.item.proposedEntityCount = 0;
      node.item.actualEntityCount = 0;
      node.item.numberOfTransactions = 0;
      this.selectedCurrencyCount = (node.item.isChecked) ? this.selectedCurrencyCount + 1 : this.selectedCurrencyCount;
    });
    this.currencyTreeData = data;
    this.getData(0);
    this.multipleCurrencySelected.emit(this.selectedCurrencyCount > 1);
  }

  updateCountrySelectorTree(data: TreeItemNode[]) {
    data.forEach(node => {
      node.item.title = node.item.cells[this.displayProperty].displayText;
      node.item.proposedEntityCount = 0;
      node.item.actualEntityCount = 0;
      node.item.numberOfTransactions = 0;
      const code = node.item.cells['country'].value;
      if (this.countryDictionary.hasOwnProperty(code)) {
        node.item.proposedEntityCount = this.countryDictionary[code].ProposedEntityCount;
        node.item.actualEntityCount = this.countryDictionary[code].EntityCount;
        node.item.numberOfTransactions = this.countryDictionary[code].TransactionCount;
      }
    });
    this.countryTreeData = data;
  }

  updateCurrencyTreeBasedOnCountryTree() {
    this.selectedCurrencyCount = 0;
    this.countryTreeData.forEach(countryNode => {
      const index =  this.currencyTreeData.findIndex(data => data.item.cells[this.displayProperty].value == countryNode.item.cells[this.displayProperty].value);
      if (index < 0) { return; }
      if (countryNode.item.isChecked) {
        this.currencyTreeData[index].item.isChecked = true;
        this.selectedCurrencyCount++;
      } else {
        this.currencyTreeData[index].item.isChecked = false;
      }
    });
    this.multipleCurrencySelected.emit(this.selectedCurrencyCount > 1);
    this.store.dispatch(new GetCurrenciesTreeDataSuccessAction(this.reportId, this.currencyType, this.currencyTreeData));
  }

  updateCountryTreeBasedOnCurrencyTree() {
    this.currencyTreeData.forEach(currencyNode => {
      const countryNodes = this.countryTreeData.filter(countryNode => countryNode.item.cells[this.displayProperty].value == currencyNode.item.cells[this.displayProperty].value);
      if (countryNodes.length >= 1) {
        countryNodes.forEach(countryNode => {
          if (currencyNode.item.isChecked) {
            countryNode.item.isChecked = true;
          } else {
            countryNode.item.isChecked = false;
          }
        });
      }
    });
    this.store.dispatch(new GetCountriesTreeDataSuccessAction(this.reportId, this.currencyType, this.countryTreeData));
  }

  updateCountrySelectorTreeForQuickSelection() {
    this.countryTreeData.forEach((node: TreeItemNode) => {
      if (node.item.proposedEntityCount + node.item.actualEntityCount > 0) {
        node.item.isChecked = true;
      } else {
        node.item.isChecked = false;
      }
    });
    return this.countryTreeData;
  }

  updateTree(treeData: TreeItemNode[], selectAll: boolean) {
    this.selectedCurrencyCount = (selectAll)? treeData.length : 0;
    treeData.forEach(node => {
      if (selectAll) {
        node.item.isChecked = true;
      } else {
        node.item.isChecked = false;
      }
    });
    this.multipleCurrencySelected.emit(this.selectedCurrencyCount > 0);
    return treeData;
  }

  getData(tabIndex: number) {
    switch (tabIndex) {
      case 0: {
        this.CurrentSearchKey = null;
        this.treeData$.next(this.currencyTreeData);
        this.allDataLoaded$.next(true);
        break;
      }
      case 1: {
        this.CurrentSearchKey = 'CountrySynonyms';
        this.treeData$.next(this.countryTreeData);
        break;
      }
    }
    this.fuseSplashScreenService.hide();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
